import BaseStore from 'stores/BaseStore';

class ContestsStore extends BaseStore {
  constructor () {
    super('cms/post/contests', 'cms/post/contests', {site_model : true});
  }
}
export default new ContestsStore()